import { render, staticRenderFns } from "./App.vue?vue&type=template&id=883f5954&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('883f5954')) {
      api.createRecord('883f5954', component.options)
    } else {
      api.reload('883f5954', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=883f5954&", function () {
      api.rerender('883f5954', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MLXC/App.vue"
export default component.exports